export default __webpack_public_path__ + "static/media/cash.6323de0e.svg";